import DataSource from "./DataSource";
import {Form} from "@/utils/Form";
import {Auth, useAuth} from "@/context/AuthProvider";
import deepEqual from "deep-equal";
import {
    UpdatePrivateRoutingDestinationsMutation,
    UpdatePrivateRoutingDestinationsMutationVariables,
    useUpdatePrivateRoutingDestinationsMutation,
} from "@/components/private-routing-destination/mutations.generated";

export default class PrivateRoutingDestinationForm extends Form<
    UpdatePrivateRoutingDestinationsMutation,
    UpdatePrivateRoutingDestinationsMutationVariables
> {
    private readonly auth: Auth;
    readonly dataSource: DataSource;

    constructor(dataSource: DataSource) {
        super("updatePrivateRoutingDestinations");
        this.hooks(useUpdatePrivateRoutingDestinationsMutation, dataSource.initialData);
        this.auth = useAuth();
        this.dataSource = dataSource;
    }

    updateFormValues() {
        this.setValues(this.dataSource.initialData);
    }

    override get hasChanged(): boolean {
        return !deepEqual(this.initialData, this.values);
    }
}
